import { getDirections } from "@lib/maps/directions";
import { selectPlanItems, selectStartingPoints } from "@store/plan/planReducer";
import { selectTravelMode, setDirections } from "@store/planRouteReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import React, { FunctionComponent, useEffect } from "react";
import { useMatch } from "react-router";

/**
 * Utility Component. Listens to changes to plan items, travel mode, start points and
 * recalculates directions as needed. Useful to include on screens where directions may
 * need to update like StartPlanModal, or even PlanList to ensure latest directions
 * are fetched.
 */
const DirectionsRefresher: FunctionComponent = React.memo(() => {
  const dispatch = useAppDispatch();
  const planItems = useAppSelector(selectPlanItems);
  const mapTravelMode = useAppSelector(selectTravelMode);
  const isPlanScreen = useMatch("/plan");
  const startPoints = useAppSelector(selectStartingPoints);

  useEffect(() => {
    if (!isPlanScreen) {
      return;
    }

    const runAsync = async () => {
      const directionsResult = await getDirections(
        planItems,
        startPoints,
        mapTravelMode,
      );
      dispatch(setDirections(directionsResult));
    };
    runAsync();
  }, [dispatch, mapTravelMode, planItems, isPlanScreen, startPoints]);

  return <></>;
});

DirectionsRefresher.displayName = "DirectionsRefresher";

export { DirectionsRefresher };
